// extracted by mini-css-extract-plugin
export default {"buttonGradient":"ButtonGradient_buttonGradient__hlB-0"};